module.exports = __webpack_public_path__ + "img/home_bg_03_4.96563b1f.png";